import React from 'react'

function ConfirmationPopup({ setIsOpenPopup, handleAttach, id }) {
    return (
        <div className="published_Deative_transprant_body">
            <div className="published_Deative_preview_container">
                <img
                    className="deactive_closeBtn"
                    src="/images/cross-circle3.svg"
                    alt=""
                    onClick={() => { setIsOpenPopup(false) }}
                />
                <div className="col-12 deactivate_msg">
                    {`Are you sure you want to delete ?`}
                </div>
                <div className="row col-12 publish_deactive_btnBox">
                    <button
                        className="btn col-sm-5 my-1 deactive_sure_btn"
                        onClick={(e) => {
                            handleAttach(id, e)
                            setTimeout(() => {
                                setIsOpenPopup(false)
                            }, 1000)
                        }}
                    >
                        Yes
                    </button>
                    <button
                        className="btn col-sm-5 my-1 deactive_sure_btn"
                        onClick={() => { setIsOpenPopup(false) }}
                    >
                        No
                    </button>
                </div>
            </div>
        </div>
    );
}

export default ConfirmationPopup